module.exports = __webpack_public_path__ + "static/media/creator-IsometricTiles.c3184957.png";